export const ELEMENT_NAMES = {
	BUTTON_CREATE: 'person-search--requestee__fab',
	BUTTON_SUBMIT: 'person-search--requestee__button--submit',
	PERSON_SEARCH: 'person-search--requestee',
	SWITCH_INPUT_OPTION: 'person-search__input-options--switch',
};

export const CSS_CLASSES = {
	BODY: 'body__container',
	FOOTER: 'footer',
	MDC_TAB_TEXT: 'mdc-tab__text-label',
	SWITCH_CONTAINER: 'switch__container',
};

export const CELL_KEYS = {
	/**
	 * Retired user.
	 * @type {string}
	 */
	RETIRED: 'Retired',
	/**
	 * Non-employee with outstanding, unacknowledged Staff Access Agreement.
	 * @type {string}
	 */
	PENDING: 'Agreement_Pending',
	/**
	 * Non-employee of type "Tenant Badge Only".
	 * @type {string}
	 */
	DENIED: 'Tenant_Badge_Only_Type',
	/**
	 * Disabled non-employee of type "Vendor".
	 * @type {string}
	 */
	DISABLED: 'Vendor_Disabled',
	/**
	 * Non-employee of type "Regulatory User".
	 * @type {string}
	 */
	RESTRICTED: 'Regulatory_User_Type',
	/**
	 * Non-employee with unacknowledged Staff Access Agreement.
	 * @type {string}
	 */
	UNACKNOWLEDGED: 'Agreement_Unacknowledged',
	/**
	 * Non-employee lacking third-party organization association.
	 * @type {string}
	 */
	UNASSOCIATED: 'Vendor_Unassociated',
};

/**
 * Visible headers used for output, selection table rendering.
 * @type {string[]}
 */
export const HEADERS = [
	'Name',
	'Network ID',
	'Job Title',
	'Department',
	'UPMC E-Sign-On ID',
	'Manager',
];

export const IDENTIFIER_TYPES = {
	EMAIL: 'Email',
	EMPLOYEE_ID: 'Employee ID',
	'UPMC_E-SIGN-ON_ID': 'UPMC E-Sign-On ID',
	NETWORK_ID: 'Network ID',
};

/**
 * Minimum, maximum permissible number of selections.
 * @type {Object}
 */
export const VALIDATION_THRESHOLD = {
	MIN: 1,
	MAX: 200,
};
